import React, {Fragment} from "react";
import {HOME_TITLE, HOME_CONTENT} from "../default_informations/home_content";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MiddleMenu from "../components/MiddleMenu";
import LeftSidebar from "../components/LeftSidebar";
import RightSidebar from "../components/RightSidebar";
import MatchesList from "../components/MatchesList";
import MatchesContext from "../components/Context/MatchesContext";

function Home() {
    const homeTitle = HOME_TITLE;
    const homeContent = HOME_CONTENT;

    return (
        <Fragment>
            <Header/>
            <main className="gg-main container-full">
                <section className="page with-left-sidebar row no-padding">
                    <MatchesContext>
                        <LeftSidebar/>
                        <div className="main-content">
                            <MiddleMenu/>
                            <div className="gg-page-with-sidebar home-page">
                                <div className="gg-page-content">
                                    <MatchesList/>
                                    <h1>{homeTitle}</h1>
                                    <div className="page_entry" dangerouslySetInnerHTML={{__html: homeContent}} />
                                </div>
                                <RightSidebar/>
                            </div>
                        </div>
                    </MatchesContext>
                </section>
            </main>
            <Footer/>
        </Fragment>
    )
}

export default Home;